import ButtonLink from "PFComponents/button/button_link";
import { Typography } from "PFComponents/typography";

export type BreadcrumbItemProps =
  | {
      label: string;
      className?: string;
      href: string;
      search?: URLSearchParams;
      state?: any;
      isCurrent?: never;
    }
  | {
      label: string;
      className?: string;
      href?: never;
      search?: never;
      state?: never;
      isCurrent: true;
    };

const buildUrl = (href: string, search?: URLSearchParams): string => {
  const searchString = search?.toString();

  return searchString ? `${href}?${searchString}` : href;
};

export const BreadcrumbItem = ({ className, href, label, search, state, isCurrent }: BreadcrumbItemProps) => {
  if (isCurrent) {
    return (
      <li className={className}>
        <Typography variant="bodyBold" textOverflow="clip">
          {label}
        </Typography>
      </li>
    );
  }

  const finalUrl = buildUrl(href!, search);

  return (
    <li className={className}>
      <ButtonLink kind="text" href={finalUrl} title={label} state={state}>
        {label}
      </ButtonLink>
    </li>
  );
};
